import "./GasAndAirFiltration.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import GasAirHero from "./sections/GasAirHero";
import GasAirOverview from "./sections/GasAirOverview";
import TechnicalFiltration from "./sections/TechnicalFiltration";
import SectorSolutions from "./sections/SectorSolutions";
import RecommendedProducts from "./sections/RecommendedProducts";
import GasLiquidSummary from "./sections/GasLiquidSummary";
import RelatedArticles from "@/components/common/RelatedArticles";
import CtaBand from "@/components/common/CtaBand";
import Footer from "@/reusable_sections/Footer";
import useHashScroll from "@/hooks/useHashScroll";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface CtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const closingCtaCopy: Record<Lang, CtaCopy> = {
  en: {
    eyebrow: "Gas & Air Filtration Engineering",
    heading: "Need High-Temperature Gas or Air Filtration Elements?",
    lead: "Specify your flow velocities, operating temperatures, and retention targets. We configure woven and sintered wire mesh assemblies for severe thermal duties.",
    secondaryLabel: "Technical Consultation"
  },
  zh: {
    eyebrow: "气体与空气过滤工程",
    heading: "需要耐高温气体或空气过滤元件？",
    lead: "请提供您的流速条件、工作温度及目标截留精度。我们为严苛热工况提供编织与多层烧结丝网滤材组合。",
    secondaryLabel: "技术咨询"
  },
  es: {
    eyebrow: "Ingeniería de filtración de gas y aire",
    heading: "¿Necesita elementos de filtración de gas o aire para alta temperatura?",
    lead: "Especifique velocidades de flujo, temperaturas de operación y retención requerida. Diseñamos conjuntos de malla tejida y sinterizada para altas exigencias.",
    secondaryLabel: "Consulta técnica"
  },
  de: {
    eyebrow: "Gas- und Luftfiltrationstechnik",
    heading: "Benötigen Sie Hochtemperatur-Filterelemente für Gas oder Luft?",
    lead: "Geben Sie Strömungsgeschwindigkeiten, Betriebstemperaturen und Abscheidegrade an. Wir konfigurieren Gewebe- und Sinterelemente für anspruchsvolle thermische Aufgaben.",
    secondaryLabel: "Technische Beratung"
  },
  fr: {
    eyebrow: "Ingénierie de filtration des gaz et de l'air",
    heading: "Besoin d'éléments de filtration haute température pour gaz ou air ?",
    lead: "Précisez débits, températures de service et seuils de rétention. Nous configurons des toiles métalliques tissées et frittées pour conditions thermiques extrêmes.",
    secondaryLabel: "Consultation technique"
  },
  pt: {
    eyebrow: "Engenharia de filtração de gases e ar",
    heading: "Precisa de elementos de filtração de alta temperatura para gases ou ar?",
    lead: "Especifique velocidades de fluxo, temperaturas de operação e retenção desejada. Configuramos conjuntos de tela tecida e sinterizada para serviços térmicos severos.",
    secondaryLabel: "Consulta técnica"
  }
};
export default function GasAndAirFiltrationPage() {
  useHashScroll();
  const {
    lang
  } = useLanguage();
  const cta = pick(lang, closingCtaCopy);
  return <div>
      <Header />
      <PageBreadcrumb page="GasAndAirFiltration" />
      <GasAirHero />
      <GasAirOverview />
      <TechnicalFiltration />
      <SectorSolutions />
      <RecommendedProducts />
      <GasLiquidSummary />
      <RelatedArticles topic="gas" />
      <CtaBand id="gas-air-closing-cta" eyebrow={cta.eyebrow} heading={cta.heading} lead={cta.lead} primary={{
      label: pick(lang, COMMON.requestQuote),
      to: "/RequestAQuotePage"
    }} secondary={{
      label: cta.secondaryLabel,
      to: "/ContactPage"
    }} />
      <Footer />
    </div>;
}